// 4. LISTE DES MÉDICAMENTS
// components/consultation/MedicationsList.tsx
import React from "react";
import { FileText, Trash2, PlusCircle } from "lucide-react";
import type { Medication } from "../../../types/medication";

interface MedicationsListProps {
  medications: Medication[];
  onAdd: () => void;
  onDelete: (index: number) => void;
}

export const MedicationsList: React.FC<MedicationsListProps> = ({
  medications,
  onAdd,
  onDelete,
}) => {
  if (medications.length === 0) return null;

  return (
    <div className="bg-green-50 border border-green-200 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <h5 className="font-semibold text-green-800 flex items-center">
          <FileText className="mr-2" size={16} />
          Médicaments prescrits ({medications.length})
        </h5>
        <button
          onClick={onAdd}
          className="text-sm px-3 py-1 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
        >
          <PlusCircle className="mr-1" size={14} />
          Ajouter
        </button>
      </div>
      
      <div className="space-y-2">
        {medications.map((med, index) => (
          <div
            key={med.id || index}
            className="bg-white rounded-lg p-3 border border-green-100 flex justify-between items-start"
          >
            <div className="flex-1">
              <div className="font-medium text-green-900">{med.name}</div>
              <div className="text-sm text-green-700">
                Dose: {med.dose} {med.doseUnit} | Durée: {med.duration} {med.durationUnit}
              </div>
              {med.advice && (
                <div className="text-xs text-green-600 mt-1">
                  Conseils: {med.advice}
                </div>
              )}
            </div>
            <div className="flex gap-2 ml-3">
              <button
                onClick={() => onDelete(index)}
                className="p-1 text-red-600 hover:bg-red-100 rounded transition-colors"
                title="Supprimer"
              >
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MedicationsList;